import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import { ProfilePicture } from '@getro/rombo';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components';
import { activeNetworkSelector } from '../../../redux/selectors';

export const MovementCompanyRenderer = ({ data }) => {
  const { colors } = useTheme();
  const activeNetwork = useSelector(activeNetworkSelector);
  const history = useHistory();
  const movement = data?.original;

  if (movement?.isSkeleton) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={48}
        viewBox="0 0 400 48"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="8" y="16" rx="3" ry="3" width="100" height="12" />
      </ContentLoader>
    );
  }

  const organization = movement?.organization;
  const companyName = organization?.name || movement?.companyName || '';
  const isLinked = !!organization?.id;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isLinked) {
      history.push(`/networks/${activeNetwork.slug}/companies/${organization.slug || organization.id}`);
    }
  };

  if (!companyName) {
    return (
      <Flex p="8px" alignItems="center" sx={{ height: '100%' }}>
        <Text fontSize="14px" color="text.subtle">
          -
        </Text>
      </Flex>
    );
  }

  return (
    <Flex
      p="8px"
      alignItems="center"
      onClick={handleClick}
      sx={{
        height: '100%',
        gap: '4px',
        cursor: isLinked ? 'pointer' : 'default',
        '&:hover': isLinked ? { bg: 'neutral.20' } : {},
      }}
    >
      {organization?.logoUrl && (
        <Box width="16px" height="16px" flex="0 0 auto">
          <ProfilePicture
            sx={{
              minWidth: '16px',
              minHeight: '16px',
            }}
            variant="square"
            imageUrl={organization.logoUrl || ''}
            name={companyName}
          />
        </Box>
      )}
      <Text
        fontSize="14px"
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {companyName}
      </Text>
    </Flex>
  );
};

MovementCompanyRenderer.propTypes = {
  data: PropTypes.object,
};

MovementCompanyRenderer.defaultProps = {
  data: {},
};
